// export const url = "https://erp.mgreeninnovations.com/api";
export const url = "https://firstfloor.agency/api";
export const IMAGE_URL = "https://firstfloor.agency/api/image/upload-image";
export const IMAGE_BASE_URL = "https://firstfloor.agency/api/image/get-image";
export const IMAGE_FETCH_URL = "https://firstfloor.agency/api/";
